import { render, staticRenderFns } from "./dxSetting.vue?vue&type=template&id=83058dbe&scoped=true&"
import script from "./dxSetting.vue?vue&type=script&lang=ts&"
export * from "./dxSetting.vue?vue&type=script&lang=ts&"
import style0 from "./dxSetting.vue?vue&type=style&index=0&id=83058dbe&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83058dbe",
  null
  
)

export default component.exports